// Route guard for planner steps.
// Uses centralized validators — never relies on step_reached alone.

import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  useDraft,
  canAccessStep,
  firstIncompleteStep,
  STEP_ROUTES,
} from '../../lib/plannerDraft';

export function PlannerRoute({ step, children }) {
  const { draft } = useDraft();
  if (!canAccessStep(step, draft)) {
    const target = STEP_ROUTES[firstIncompleteStep(draft)];
    return <Navigate to={target} replace />;
  }
  return children;
}

export default PlannerRoute;
